export default [{
    path: '/messages',
    name: 'messages',
    component: () =>
        import ('@/views/modules/contacts/contacts-list/ContactsList.vue'),
    meta: {
        resource: 'ACL',
        pageTitle: 'Contactos',
        breadcrumb: [{
            text: 'Lista de contactos',
            active: true
        }]
    }
}]